import { Options } from "./PltUserAuthenticationForm.types";

export const getDefaultOption = (value: boolean | undefined) => {
  if (typeof value === "undefined") {
    return Options.default;
  }
  return value ? Options.on : Options.off;
};
